import React, { useState, useEffect } from 'react';
import MD from './MD';

export default function ReportViewer({ reportId, authToken, onClose, onDiscussWithAI }) {
  const [report, setReport] = useState(null);
  const [err, setErr]       = useState('');

  useEffect(() => {
    fetch(`/api/reports/${reportId}`, { headers: { Authorization: `Bearer ${authToken}` } })
      .then(r => r.json())
      .then(d => { if (d.error) setErr(d.error); else setReport(d); })
      .catch(() => setErr('Fehler beim Laden des Reports.'));
  }, [reportId, authToken]);

  const download = () => {
    if (!report?.content) return;
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([report.content], { type: 'text/markdown' }));
    a.download = report.file_path?.split('/').pop() || `report-${reportId}.md`;
    a.click();
  };

  return (
    <div className="modal-backdrop" onClick={e => e.target===e.currentTarget&&onClose()}>
      <div className="modal">
        <div className="modal-header">
          <span className="modal-title">Report #{reportId}</span>
          <div className="modal-header-actions">
            {report && onDiscussWithAI && (
              <button className="btn-primary" onClick={() => onDiscussWithAI(report)} title="Diesen Report in einem neuen Chat besprechen">
                💬 Mit KI besprechen
              </button>
            )}
            {report && <button className="btn-outline" onClick={download} title="Report als Markdown-Datei herunterladen">↓ Markdown</button>}
            <button className="btn-outline" onClick={onClose} title="Report-Ansicht schließen">✕ Schließen</button>
          </div>
        </div>
        <div className="modal-body">
          {err  && <p className="inline-error">{err}</p>}
          {!report && !err && <div className="skeleton-lines"><div/><div/><div/><div/><div/></div>}
          {report && <MD content={report.content} />}
        </div>
      </div>
    </div>
  );
}
